import React from 'react';
import { useAuth0 } from '../contexts/AuthContext';
import './Settings.css';

const Settings = () => {
  const { user, logout } = useAuth0();

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <div className="settings-container">
      <div className="settings-header">
        <h1>Settings</h1>
      </div>

      <div className="settings-content">
        <div className="settings-section">
          <h2>Profile Information</h2>
          <div className="profile-info">
            {user?.picture && (
              <img
                src={user.picture}
                alt={user.name}
                className="profile-picture"
                style={{ width: '80px', height: '80px', borderRadius: '50%', marginBottom: '1rem' }}
              />
            )}
            <div className="info-row">
              <label>Name:</label>
              <span>{user?.name || 'Not set'}</span>
            </div>
            <div className="info-row">
              <label>Email:</label>
              <span>{user?.email || 'Not set'}</span>
            </div>
            <div className="info-row">
              <label>Email Verified:</label>
              <span>{user?.email_verified ? 'Yes' : 'No'}</span>
            </div>
            <div className="info-row">
              <label>Last Updated:</label>
              <span>{user?.updated_at ? new Date(user.updated_at).toLocaleDateString() : 'N/A'}</span>
            </div>
          </div>
        </div>

        <div className="settings-section">
          <h2>Account</h2>
          <p style={{ color: '#666', marginBottom: '1rem' }}>
            Your account is managed by Auth0. To update your profile, password, or enable multi-factor authentication, please visit your Auth0 account settings.
          </p>
          <button
            onClick={handleLogout}
            className="btn-danger"
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#ef4444',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
